import React, { useState, useEffect } from 'react'
import SoapNotesForm from '../soap-notes-form/SoapNotesForm'
import SoapNotesService from '../../../../../../services/api/soapnotes.service'
import APIResponse from '../../../../../templates/components/APIResponse'
import DimLoader from '../../../../../templates/components/DimLoader'
const SoapNotesEdit = (props) => {
    const [apiResponse, setApiResponse] = useState()
    const [isSubmitted, setIsSubmitted] = useState(false)
    const onSuccess = (message) => {
        if (props.refresh) {
            props.refresh()
        }
        if (props.onClose) {
            props.onClose()
        }
        if (props.exitHandler) {
            props.exitHandler()
        }
    }
    const submitHandler = (data) => {
        setIsSubmitted(true)
        let reqObj = {
            id: data.id,
            assessment: data.assessment || null,
            objective: data.objective || null,
            plan: data.plan || null,
            practiceLocationId: data.practiceLocationId,
            subjective: data.subjective || null,
            appointmentId : data.appointmentId || null
        }
        SoapNotesService.editSoapNotes(data.patientId, reqObj)
            .then(res => {
                setApiResponse(res)
            })
            .catch(err => {
                setApiResponse(err)
            })
            .finally(() => {
                setIsSubmitted(false)
            })

    }
    return (
        <>
            {isSubmitted ? <DimLoader loadMessage="Processing..." /> : null}
            <SoapNotesForm isEdit initialData={props.initialData} patientId={props?.initialData?.patientId} onClose={() => props.onClose()} submitLabel="Update" submitHandler={submitHandler} />
            <APIResponse apiResponse={apiResponse} onSuccess={onSuccess} toastOnSuccess={true} />
        </>

    )
}

export default SoapNotesEdit